class RecentlyViewedProducts {

  constructor() {
    this.listeners();
  }

  listeners() {
    this.setRecentlyViewedProducts();

    const recentlyViewedProducts = JSON.parse(localStorage.getItem("recentlyViewedProducts"));

    if (recentlyViewedProducts && recentlyViewedProducts.length) {
      const handleIntersection = (entries, observer) => {
        const requests = [];
        
        if (!entries[0].isIntersecting) return;

        observer.unobserve(recentlyViewedProductsSection);
        
        recentlyViewedProducts.reverse().forEach((product) => {
          requests.push(fetch(`${product.url}?section_id=stmt-product-card`));  
        });

        Promise.all(
          requests
        ).then((responses) => {
          return Promise.all(responses.map((response) => {
            return response.text();
          }));
        }).then((products) => {
          const recentlyViewedList = document.querySelector('.js-recently-viewed-list');

          products.forEach((product) => {
            const parser = new DOMParser();
            const productHtml = parser.parseFromString(product, "text/html");
            const card = productHtml.querySelector('.js-card');

            if (recentlyViewedList && card) {
              recentlyViewedList.innerHTML += `
                <div class="site-slider__slide splide__slide">
                  ${card.innerHTML}
                </div>
              `
            }
          });

          const productCarousel = recentlyViewedList.closest('.product-carousel');
          if (productCarousel && products.length <= 3) {
            productCarousel.classList.add('product-carousel--centered');
          }

          document.dispatchEvent(new Event('asyncSlider:ready'));
        }).catch((error) => {
          console.error(error);
        });
      }

      const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
      const recentlyViewedProductsSection = document.querySelector('.recently-viewed-products');

      observer.observe(recentlyViewedProductsSection);
    } else {
      const recentlyViewedProductsSection = document.querySelector('.recently-viewed-products');

      if (recentlyViewedProductsSection) {
        recentlyViewedProductsSection.classList.add('recently-viewed-products--hidden');
      }
    }
  }

  setRecentlyViewedProducts() {
    const productData = {
      url: window.productStrings.url,
      handle: window.productStrings.handle
    };

    if (productData.handle) {
      const productList = [];
      const limit = 12;
      const storedProducts = localStorage.getItem("recentlyViewedProducts");
  
      productList.push(productData);
      
      if (storedProducts === null) {
        localStorage.setItem("recentlyViewedProducts", JSON.stringify(productList));
      } else if (storedProducts) {
        const storedproducts = localStorage.getItem("recentlyViewedProducts");
        const storedProductsLength = (JSON.parse(storedproducts) || []).length;
        const duplicate = storedproducts.includes(productData.handle);
  
        if (storedProductsLength < limit && !duplicate) {
          let products = JSON.stringify(JSON.parse(storedproducts).concat(productList));
          localStorage.setItem("recentlyViewedProducts", products);
        } else if (storedProductsLength >= limit && !duplicate) {
          const parsedProducts = JSON.parse(storedproducts);
          parsedProducts.shift();
          let products = JSON.stringify(parsedProducts.concat(productList));
          localStorage.setItem("recentlyViewedProducts", products);
        }
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', function() {
  new RecentlyViewedProducts();
});
